<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>每日数据监控</div>
    </div>

    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <div style="width: 75%">
            <canvas id="canvas" />
          </div>
          <!--<el-table v-loading="tableLoading" height="600" ref="multipleTable" :data="resData" tooltip-effect="dark" style="width: 100%">-->
          <!--<el-table-column prop="the_day" label="日期" width="120" align="center">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="effect_pay_num" label="应开单件数" width="120" align="center">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="should_buy_num" label="实际应开单件数" show-overflow-tooltip align="center">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="real_buy_num" label="成功开单件数" show-overflow-tooltip align="center">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="dabiao_num" label="打标件数" show-overflow-tooltip align="center">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="stock_in_num" label="入库件数" show-overflow-tooltip align="center">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="allot_num" label="配货件数" show-overflow-tooltip align="center">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="stock_out_num" label="出库件数" show-overflow-tooltip align="center">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="blp_num" label="不良品件数" show-overflow-tooltip align="center">-->
          <!--</el-table-column>-->

          <!--<el-table-column prop="deal_blp_num" label="处理不良品件数" show-overflow-tooltip align="center">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="return_num" label="用户退回件数" show-overflow-tooltip align="center">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="work_done_num" label="售后工单完成件数" show-overflow-tooltip align="center">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="spot_num" label="现货库存件数" show-overflow-tooltip align="center">-->
          <!--</el-table-column>-->

          <!--</el-table>-->
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<template>
  <div>
    <!--创建一个echarts的容器-->
    <div id="order_line" style="width: 100%; height: 500px"></div>
    <div id="stock_line" style="width: 100%; height: 500px"></div>
    <div id="blp_line" style="width: 100%; height: 500px"></div>
  </div>
</template>

<script>
export default {
  name: "DayMonitor",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {},
      loading: false,
      url: "/erp/DayMonitor/getMonitorList",
      curPage: 1,
      tableLoading: false,
      order_line: null,
      stock_line: null,
      blp_line: null,
    };
  },
  computed: {
    filteredForm() {
      const { form } = this;
      Object.keys(form).forEach((key) => {
        if (form[key] === undefined || form[key] === "" || form[key] === null) {
          delete form[key];
        }
      });
      return form;
    },
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.order_line = this.$echarts.init(document.getElementById("order_line"));
    this.stock_line = this.$echarts.init(document.getElementById("stock_line"));
    this.blp_line = this.$echarts.init(document.getElementById("blp_line"));
    // 绘制图表
  },
  methods: {
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.order_line.setOption({
            title: { text: "开单数据" },
            tooltip: {
              trigger: "axis",
            },
            xAxis: {
              boundaryGap: false,
              data: res.data.data.day,
            },
            legend: {
              data: res.data.data.order_line_legend,
            },
            yAxis: {},
            series: res.data.data.order_line,
          });
          this.stock_line.setOption({
            title: { text: "打标入库出库库存" },
            tooltip: {
              trigger: "axis",
            },
            xAxis: {
              boundaryGap: false,
              data: res.data.data.day,
            },
            legend: {
              data: res.data.data.stock_line_legend,
            },
            yAxis: {},
            series: res.data.data.stock_line,
          });
          this.blp_line.setOption({
            title: { text: "不良品和售后" },
            tooltip: {
              trigger: "axis",
            },
            xAxis: {
              boundaryGap: false,
              data: res.data.data.day,
            },
            legend: {
              data: res.data.data.blp_line_legend,
            },
            yAxis: {},
            series: res.data.data.blp_line,
          });
          // this.resData = res.data.data;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/monitor/DayMonitor.vue